import React from 'react';
import './StatusBar.css';

export function StatusBar({ message, statusType }) {
  if (!message) return null;
  return (
    <div
      className={`status-bar${statusType === 'error' ? ' status-bar--error' : ''}`}
      role="status"
      aria-live="polite"
    >
      <p>{message}</p>
    </div>
  );
}
